import React from "react";
import Select from "react-select";
import loadImage from "blueimp-load-image";
import PendingIconImage from "../../../assets/media/icons/pending.png";
import IconStore from "../../Chatbot/components/IconStore";
import "./index.css";
import Firebase from "../../../firebasehelper";
import { CurrencyOptions } from "../../../Constants/retailer";
import { user_actions } from "../../../Utils/Constants";
import { pages } from "../../../Constants/selections";
class ApproveBrandTokenEarning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      description: "",
      token: 0,
      premier_token: "",
      loading: true,
      territory: "UK",
    };
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedTokenEarning !== this.props.selectedTokenEarning) {
      const { brand, pending, page, action, icon, img_url } =
        this.props.selectedTokenEarning;
      console.log(
        "this.props.selectedTokenEarning",
        this.props.selectedTokenEarning
      );
      if (pending) {
        this.setState({ loading: true });
        let brand_data = await Firebase.getBrandDataByName(brand);
        this.setState({
          logo: brand_data.logo,
          icon: icon || "",
          img_url: img_url || "",
          territory: brand_data.territory || "UK",
          title: this.props.selectedTokenEarning.title || "",
          description: this.props.selectedTokenEarning.description || "",
          token: this.props.selectedTokenEarning.token || 0,
          page: { value: page, label: page },
          user_action: user_actions.find((item) => item.value === action),
          premier_token: this.props.selectedTokenEarning.premier_token
            ? `${CurrencyOptions[brand_data.territory || "UK"]}${
                this.props.selectedTokenEarning.premier_token
              }`
            : "",
          loading: false,
        });
      }
    }
  }
  handleInputChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };
  onChangePremierToken = ({ target: { value } }) => {
    const { territory } = this.state;
    let newValue = value.split(".");
    if (newValue.length > 1) {
      newValue =
        newValue.slice(0, -1).join("") + "." + newValue[newValue.length - 1];
    } else {
      newValue = value;
    }
    const countDecimals = function (number) {
      if (Math.floor(number) === Number(number)) return 0;
      return number.toString().split(".")[1].length || 0;
    };
    let number = Number(newValue.replace(/[^0-9\.]+/g, ""));
    const decimalPoints = countDecimals(newValue);
    if (decimalPoints >= 3) {
      number = number * 10;
    } else {
      number = number / Math.pow(10, 2 - decimalPoints);
    }
    this.setState({
      premier_token: `${CurrencyOptions[territory]}${number.toFixed(2)}`,
    });
  };

  onSelectImage = (icon) => {
    this.setState({ icon, showChooseIcon: false });
  };

  onApprove = () => {
    let {
      title,
      description,
      token,
      premier_token,
      page,
      task_img,
      icon,
      user_action,
    } = this.state;
    const { onApprove } = this.props;
    if (premier_token) premier_token = premier_token.substring(1);
    onApprove(
      {
        title,
        description,
        token,
        premier_token,
        page: page.value,
        icon,
        action: user_action.value,
      },
      task_img
    );
  };
  checkValidation = () => {
    let {
      title,
      description,
      token,
      premier_token,
      page,
      task_img,
      icon,
      user_action,
      img_url,
    } = this.state;
    return (
      title &&
      description &&
      page &&
      (task_img || img_url) &&
      user_action &&
      icon &&
      (token || premier_token)
    );
  };
  selectedFile = (e) => {
    let _this = this;
    let id = e.target.id;
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      loadImage.parseMetaData(content, function (data) {
        //default image orientation
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        loadImage(
          content,
          function (canvas) {
            var base64data = canvas.toDataURL("image/png");
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            _this.setState({ [id]: img_src });
          },
          {
            canvas: true,
            orientation: orientation,
          }
        );
      });
    }
  };
  render() {
    const {
      title,
      description,
      token,
      premier_token,
      page,
      logo,
      loading,
      icon,
      showChooseIcon,
      territory,
      user_action,
      img_url,
    } = this.state;
    return (
      <div
        className="modal fade token-earning-dialog"
        id="approve_brand_token_earning_modal"
        tabIndex="-2"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content add-token-earning-content">
            <div className="modal-header">
              <h5 className="modal-title">Publish requested task</h5>
              {loading ? "Loading..." : <img src={logo} height="40" />}
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1 brand-token-earning-dialog-body">
              <div className="icon-container">
                <button
                  type="button"
                  className="btn btn-warning choose-icon-btn"
                  onClick={() => {
                    this.setState({ showChooseIcon: true });
                  }}
                >
                  Choose Icon
                </button>
                <img
                  src={icon ? icon : PendingIconImage}
                  width="40"
                  alt="icon"
                />
              </div>
              {showChooseIcon && (
                <IconStore onSelectImage={this.onSelectImage} />
              )}
              <p className="token-earning-property-title">
                Token Earning Title
              </p>
              <input
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("title")}
                maxLength="24"
                value={title}
              />
              <p className="bottom-text">Max characters: 24</p>
              <p className="token-earning-property-title">
                Token Earning Description
              </p>
              <textarea
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("description")}
                value={description}
              />
              <p className="token-earning-property-title">
                Shopping Token Value
              </p>
              <input
                type="number"
                placeholder="0"
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("token")}
                value={token}
              />
              <p className="token-earning-property-title">
                Premier Token Value
              </p>
              <input
                type="text"
                placeholder={`${CurrencyOptions[territory]}00.00`}
                className="form-control form-control-md form-control-alt bill-price"
                onChange={this.onChangePremierToken}
                value={premier_token}
              />
              <div className="page-action-container">
                <div style={{ width: "45%" }}>
                  <p className="token-earning-property-title">Pages</p>
                  <div className="page-select-container">
                    <Select
                      options={Object.values(pages).map((page) => ({
                        value: page.id,
                        label: page.name,
                      }))}
                      onChange={(value) => this.setState({ page: value })}
                      value={page}
                    ></Select>
                  </div>
                </div>
                <div style={{ width: "45%" }}>
                  <p className="token-earning-property-title">User Actions</p>
                  <div
                    className="page-select-container"
                    style={{ width: "100%" }}
                  >
                    <Select
                      options={user_actions}
                      onChange={(value) =>
                        this.setState({ user_action: value })
                      }
                      value={user_action}
                    ></Select>
                  </div>
                </div>
              </div>
              <p className="token-earning-property-title">Image</p>
              <input
                type="file"
                id="task_img"
                name="task-file-input"
                accept="image/*"
                onChange={this.selectedFile}
              />
              {img_url && <img src={img_url} height="50" />}
              <div className="token-earning-footer">
                <button
                  className="btn"
                  disabled={!this.checkValidation()}
                  onClick={this.onApprove}
                  data-dismiss="modal"
                >
                  Approve
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ApproveBrandTokenEarning;



// WEBPACK FOOTER //
// ./src/screens/BrandTokenEarning/ApproveEarningModal/index.js